<template>
  <div class="full-screen-wrap" @click.stop>
      <span class="material-icons" @click="hidePhoneOverlay">
        close
      </span>
      <img :src="$images.phoneOverlay" alt="">
  </div>
</template>

<script>
export default {
  methods: {
    hidePhoneOverlay () {
      localStorage.setItem('hidePhoneOverlay', true)
      this.$emit('hide-overlay')
    }
  }
}
</script>

<style scoped lang='scss'>
.full-screen-wrap {
    position: fixed;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 9999999;
    img {
        width: 100%;
        height: 100%;
        z-index: 9999999;
    }
}
.material-icons {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  color: #FFF;
}
</style>